import React from 'react';
import {
  CustomTableRow,
  CustomTableCell,
} from 'src/components/MainPage/_shared/Table';

type NoItemsCellProps = {
  colSpan: number;
  text?: string;
};

export const NoItemsCell = ({
  colSpan,
  text = 'Нет данных',
}: NoItemsCellProps) => {
  return (
    <CustomTableRow>
      <CustomTableCell colSpan={colSpan} align="center" sx={{ pt: 2, pb: 4 }}>
        {text}
      </CustomTableCell>
    </CustomTableRow>
  );
};
